'use client';

import React, { useEffect, useState } from 'react';
import { getDailyPanchang, DailyPanchangRecord } from '@/lib/api/client';

export function LivePanchangHeroCard({ locale }: { locale: string }) {
  const [record, setRecord] = useState<DailyPanchangRecord | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    getDailyPanchang({ lat: 28.6139, lon: 77.2090 })
      .then((data) => {
        if (mounted) {
          setRecord(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setError(true);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (error || (!record && !loading)) {
    return null;
  }

  const isHindi = locale === 'hi';
  const tithiText = record
    ? `${record.panchang.tithi.paksha} ${record.panchang.tithi.name}`
    : '...';
  const nakshatraText = record ? record.panchang.nakshatra.name : '...';
  const rahuKaalText = record
    ? `${record.muhurtas.rahu_kaal.start} ${isHindi ? 'से' : 'to'} ${record.muhurtas.rahu_kaal.end}`
    : '...';

  return (
    <div
      className="p-3.5 sm:p-4 rounded-2xl flex flex-col gap-1.5 min-w-[210px] bg-gradient-to-br from-white/16 to-white/[0.03] border border-white/28 shadow-[inset_0_1px_0_rgba(255,255,255,0.45),0_20px_50px_-10px_rgba(0,8,40,0.7)] backdrop-blur-xl animate-[float_7s_ease-in-out_infinite]"
      data-testid="live-panchang-hero-card"
    >
      <div className="flex items-center justify-between gap-2 text-[10px] font-semibold tracking-wider text-[#b9c6ff]">
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-[#8dffc9] animate-pulse" />
          <span>{isHindi ? 'दैनिक पंचांग' : 'LIVE PANCHANG'}</span>
        </div>
        <span className="text-[10px] font-medium text-[rgba(220,236,255,0.75)]">
          {isHindi ? 'नई दिल्ली' : 'New Delhi'}
        </span>
      </div>
      <div className="grid grid-cols-[auto_1fr] gap-x-3.5 gap-y-1 text-xs text-white">
        <span className="text-[rgba(225,238,255,0.65)]">{isHindi ? 'तिथि' : 'Tithi'}</span>
        <span className="font-semibold truncate">{tithiText}</span>
        <span className="text-[rgba(225,238,255,0.65)]">{isHindi ? 'नक्षत्र' : 'Nakshatra'}</span>
        <span className="font-semibold truncate">{nakshatraText}</span>
        <span className="text-[rgba(225,238,255,0.65)]">{isHindi ? 'राहु काल' : 'Rahu Kaal'}</span>
        <span className="font-semibold truncate">{rahuKaalText}</span>
      </div>
    </div>
  );
}
